import { AuthorizationModuleClientType } from '../../../types';

export const AuthorizationModuleCustomClient: Partial<AuthorizationModuleClientType> = {};
